import { buildModuleApi } from "../../../../../_CORE/API/_ApiUtil/_buildModuleApi";

const { API, PERMISSIONS, CONSTANTS, ENDPOINTS } = buildModuleApi({
    prefix: "TAGS", uri: "tags",
    exclude: ["DETAIL", "ARCHIVE", "RESTORE", "ARCHIVED", "BULK_CREATE", "BULK_ARCHIVE",
        "BULK_RESTORE", "BULK_REMOVE_REQUEST", "BULK_REMOVE_CONFIRM"],
    withExtra: false,

    overrides: {
        LIST: { url: "/tags" },
        CREATE: { url: "/tags" },
        UPDATE: { url: "/tags" },
        REMOVE: { url: "/tags" },
    },
    extraActions: {
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

export const TAGS_API = API;
export const TAGS_CONSTANTS = CONSTANTS;
export const TAGS_ENDPOINTS = ENDPOINTS;
export const TAGS_PERMISSIONS = PERMISSIONS;
